
import {createSlice} from '@reduxjs/toolkit'
import { fetchtaskstatus } from '../../action/master/taskstatusAction'

interface taskstatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: taskstatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const taskstatusSlice = createSlice({
  name: 'taskstatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchtaskstatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchtaskstatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchtaskstatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default taskstatusSlice.reducer
